
  import { Debounce } from '@/utils/decorators'
  import { fixPrice } from '@/utils/general'
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { Prop, Watch } from 'vue-property-decorator'

@Component({})
  export default class FinancialEvaluationReport extends Vue {
  @Prop() reports
  @Prop({ default: undefined, type: Number }) idExecutive
  @Prop({ default: '', type: String }) role
  executives = []
  reportsAttribute = []
  fixPrice = fixPrice

  filterByExecutive (executive, id?) {
    if (id) {
      const filterById = this.reportsAttribute.filter(report => report.executive === id)
      executive = filterById?.[0]?.executiveName
    }
    return this.reportsAttribute.filter(report =>
      report.executiveName === executive
    )
  }

  getData () {
    if (!this.reports) return
    const reports = this.reports.getAppraisalFinancialReport
    if (!reports) return
    this.reportsAttribute = reports

    const executives = []
    reports.forEach(report => {
      if (!executives.includes(report.executiveName)) {
        executives.push(report.executiveName)
      }
    })
    this.executives = executives
  }

  goToAppraisal (id) {
    const { role } = this
    if (!role.length) return

    const dtRoute = `/datatable/${role}/${role}_appraisals`
    const filter = {
      filter: 'all',
      page: '1',
      period: 'last_24_months',
      size: '20',
      search: JSON.stringify([{ id: { _eq: id } }]),
    }

    window.open(this.$router.resolve({ path: dtRoute, query: filter }).href, '_blank')
  }

  get totalProyectedUtility () {
    let count = 0
    this.reportsAttribute.forEach(report => count += report.projectedUtility)
    return count
  }

  get totalInvestment () {
    let count = 0
    if (!this.idExecutive) {
      this.reportsAttribute.forEach(report => {
        count += Number(report.appraised)
      })
    } else {
      const filterById = this.filterByExecutive(undefined, this.idExecutive)
      filterById.forEach(report => {
        count += Number(report.appraised)
      })
    }
    return count
  }

  @Watch('reports', { immediate: true, deep: true })
  @Debounce(500)
  onReportsChange () {
    this.getData()
  }
  }

